"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePaymentToken = exports.SourgumInvoicePaymentInput = exports.WaysteInvoicePaymentInput = exports.InvoicePaymentInput = void 0;
const typebox_1 = require("@sinclair/typebox");
const invoice_1 = require("../invoice");
/**
 * @deprecated - Moved to invoice
 */
exports.InvoicePaymentInput = typebox_1.Type.Object({
    paymentToken: typebox_1.Type.String(),
    stripeToken: typebox_1.Type.String(),
    stripeCustomer: typebox_1.Type.String(),
    amount: typebox_1.Type.Integer(),
});
/**
 * @deprecated - Moved to invoice
 */
exports.WaysteInvoicePaymentInput = typebox_1.Type.Object({
    stripeSourceToken: typebox_1.Type.String(),
    InvoicePaymentToken: typebox_1.Type.String(),
});
/**
 * @deprecated - Moved to invoice
 */
exports.SourgumInvoicePaymentInput = typebox_1.Type.Object({
    stripeSourceToken: typebox_1.Type.String(),
    InvoicePaymentToken: typebox_1.Type.String(),
});
/**
 * @deprecated - Moved to invoice
 */
exports.InvoicePaymentToken = typebox_1.Type.Object({
    customerID: typebox_1.Type.String(),
    invoiceDetails: typebox_1.Type.Pick(invoice_1.CustomerInvoiceTransport, ['id', 'invoiceNumber', 'remainingBalance']),
});
//# sourceMappingURL=InvoicePayment.js.map